import { ILopTuNguyenSelectRequest } from "../../model/request/lop-tin-chi/ILopTuNguyenSelectRequest";
import { IHeSoLopTuNguyenUpdateOneRequest } from "../../model/request/thiet-lap/IHeSoLopTuNguyenUpdateOneRequest";
import { IAccHeSoLopTuNguyen } from "../../model/respone/thiet-lap/IAccHeSoLopTuNguyen";
import { apiClient } from "../apiClient";
export const HE_SO_LOP_TU_NGUYEN_ENDPOINT = "he-so-lop-tu-nguyen";
export const heSoLopTuNguyenApi = {
  Insert: (payload: IAccHeSoLopTuNguyen) =>
    apiClient.post(`${HE_SO_LOP_TU_NGUYEN_ENDPOINT}`, payload),
  Update: (payload: IAccHeSoLopTuNguyen) =>
    apiClient.put(`${HE_SO_LOP_TU_NGUYEN_ENDPOINT}`, payload),
  Delete: (id: number) =>
    apiClient.delete(`${HE_SO_LOP_TU_NGUYEN_ENDPOINT}/${id}`),
  SelectHeSo: ({ hoc_ky, nam_hoc }: any) =>
    apiClient.get(
      `${HE_SO_LOP_TU_NGUYEN_ENDPOINT}/select-he-so/${hoc_ky}/${nam_hoc}`
    ),

  SelectLopTuNguyen: (payload: ILopTuNguyenSelectRequest) =>
    apiClient.post(
      `${HE_SO_LOP_TU_NGUYEN_ENDPOINT}/select-lop-tu-nguyen`,
      payload
    ),

  Sync: (payload: ILopTuNguyenSelectRequest) =>
    apiClient.post(`${HE_SO_LOP_TU_NGUYEN_ENDPOINT}/sync`, payload),

  UpdateHoLopTuNguyen: (payload: IHeSoLopTuNguyenUpdateOneRequest) =>
    apiClient.post(
      `${HE_SO_LOP_TU_NGUYEN_ENDPOINT}/update-he-so-loptunguyen`,
      payload
    ),
};
